/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AuthTokenApiContract,
  ChangePasswordApiInContract,
  ErrorApiOutContract,
  ErrorDescription,
  ExecutionResult,
  ProfileDoctorApiInContract,
  ProfileDoctorApiOutContract,
  ProfileSettingsDoctorApiContract,
  PutProfileImageBody
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Retrieves the profile information for the current user.
 */
export const getProfile = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ProfileDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/profile`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProfileInfiniteQueryKey = () => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/profile`
    ] as const;
    }

export const getGetProfileQueryKey = () => {
    return [
    `https://providers-api.api.quick.md/api/v1/profile`
    ] as const;
    }

    
export const getGetProfileInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileInfiniteQueryError = void | ErrorApiOutContract


export function useGetProfileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the profile information for the current user.
 */

export function useGetProfileInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves the profile information for the current user.
 */
export const prefetchGetProfileInfiniteQuery = async <TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProfileInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = void | ErrorApiOutContract


export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the profile information for the current user.
 */

export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves the profile information for the current user.
 */
export const prefetchGetProfileQuery = async <TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProfileQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileSuspenseQueryError = void | ErrorApiOutContract


export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the profile information for the current user.
 */

export function useGetProfileSuspense<TData = Awaited<ReturnType<typeof getProfile>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProfileSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetProfileSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the profile information for the current user.
 */

export function useGetProfileSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProfile>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates the profile information for the current user.
 */
export const putProfile = (
    profileDoctorApiInContract: ProfileDoctorApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<ProfileDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: profileDoctorApiInContract
    },
      options);
    }
  


export const getPutProfileMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfile>>, TError,{data: ProfileDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProfile>>, TError,{data: ProfileDoctorApiInContract}, TContext> => {

const mutationKey = ['putProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProfile>>, {data: ProfileDoctorApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  putProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putProfile>>>
    export type PutProfileMutationBody = ProfileDoctorApiInContract
    export type PutProfileMutationError = void | ErrorApiOutContract

    /**
 * @summary Updates the profile information for the current user.
 */
export const usePutProfile = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfile>>, TError,{data: ProfileDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProfile>>,
        TError,
        {data: ProfileDoctorApiInContract},
        TContext
      > => {

      const mutationOptions = getPutProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Updates the profile settings for the current user. It allows modifying various notification
preferences, such as reminders and notifications specific to shifts, patient activity, and bookings.
 */
export const putProfileSettings = (
    profileSettingsDoctorApiContract: ProfileSettingsDoctorApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/profile/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: profileSettingsDoctorApiContract
    },
      options);
    }
  


export const getPutProfileSettingsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfileSettings>>, TError,{data: ProfileSettingsDoctorApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProfileSettings>>, TError,{data: ProfileSettingsDoctorApiContract}, TContext> => {

const mutationKey = ['putProfileSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProfileSettings>>, {data: ProfileSettingsDoctorApiContract}> = (props) => {
          const {data} = props ?? {};

          return  putProfileSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProfileSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putProfileSettings>>>
    export type PutProfileSettingsMutationBody = ProfileSettingsDoctorApiContract
    export type PutProfileSettingsMutationError = void | ErrorApiOutContract

    /**
 * @summary Updates the profile settings for the current user. It allows modifying various notification
preferences, such as reminders and notifications specific to shifts, patient activity, and bookings.
 */
export const usePutProfileSettings = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfileSettings>>, TError,{data: ProfileSettingsDoctorApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProfileSettings>>,
        TError,
        {data: ProfileSettingsDoctorApiContract},
        TContext
      > => {

      const mutationOptions = getPutProfileSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Updates the profile image for the current user.
 */
export const putProfileImage = (
    putProfileImageBody: PutProfileImageBody,
 options?: SecondParameter<typeof fetcher>,) => {
      
      const formData = new FormData();
if(putProfileImageBody.image !== undefined) {
 formData.append(`image`, putProfileImageBody.image)
 }

      return fetcher<ExecutionResult>(
      {url: `https://providers-api.api.quick.md/api/v1/profile/image`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutProfileImageMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfileImage>>, TError,{data: PutProfileImageBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProfileImage>>, TError,{data: PutProfileImageBody}, TContext> => {

const mutationKey = ['putProfileImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProfileImage>>, {data: PutProfileImageBody}> = (props) => {
          const {data} = props ?? {};

          return  putProfileImage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProfileImageMutationResult = NonNullable<Awaited<ReturnType<typeof putProfileImage>>>
    export type PutProfileImageMutationBody = PutProfileImageBody
    export type PutProfileImageMutationError = void | ErrorApiOutContract

    /**
 * @summary Updates the profile image for the current user.
 */
export const usePutProfileImage = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfileImage>>, TError,{data: PutProfileImageBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProfileImage>>,
        TError,
        {data: PutProfileImageBody},
        TContext
      > => {

      const mutationOptions = getPutProfileImageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | PasswordNotValid | New password is invalid |
| 400 | CredentialsNotValid | Old password is invalid |
| 400 | PasswordResetRequired | Must go through password reset flow |
| 400 | PasswordDetectedInBreach | Password detected in breach must be reset |
 * @summary Change password
 */
export const putProfilePassword = (
    changePasswordApiInContract: ChangePasswordApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<AuthTokenApiContract>(
      {url: `https://providers-api.api.quick.md/api/v1/profile/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordApiInContract
    },
      options);
    }
  


export const getPutProfilePasswordMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfilePassword>>, TError,{data: ChangePasswordApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProfilePassword>>, TError,{data: ChangePasswordApiInContract}, TContext> => {

const mutationKey = ['putProfilePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProfilePassword>>, {data: ChangePasswordApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  putProfilePassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProfilePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof putProfilePassword>>>
    export type PutProfilePasswordMutationBody = ChangePasswordApiInContract
    export type PutProfilePasswordMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Change password
 */
export const usePutProfilePassword = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProfilePassword>>, TError,{data: ChangePasswordApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProfilePassword>>,
        TError,
        {data: ChangePasswordApiInContract},
        TContext
      > => {

      const mutationOptions = getPutProfilePasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    